"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const cloneUtils_1 = require("../cloneUtils");
exports.cloneFromTemplateArtifact = cloneUtils_1.unSupportedClone;
//# sourceMappingURL=clone.js.map